import { useAnnounceParcelTrackerContext } from "./announce-parcel-tracker-context";
import React, { Fragment, useState } from "react";
import { Button, DialogActions, DialogContent, DialogTitle, FormControl, FormLabel, TextField, Typography } from "@mui/material";
import { ScanFieldControlled } from "../../../../common/component/scan-field-controlled/scan-field-controlled";
import { Parcel } from "../../../model/parcel";
import { t } from "i18next";

interface IAnnounceParcelTrackerSingleFormProps {
    parcel: Parcel;
    onSubmit: (carrier: string, tracker: string) => Promise<void>;
    onCancel: () => void;
}

export const AnnounceParcelTrackerSingleForm = (props: IAnnounceParcelTrackerSingleFormProps) => {
    const { carrier } = useAnnounceParcelTrackerContext();
    const [carrierValue, setCarrierValue] = useState<string>(carrier);
    const [parcelTrackerValue, setParcelTrackerValue] = useState<string>("");

    const [isAnnouncementInProgress, setIsAnnouncementInProgress] = useState<boolean>(false);

    const handleParcelTrackerScanned = (value: string) => { setCarrierValue(value); };
    const handleParcelTrackerAnnouncement = async () => {
        setIsAnnouncementInProgress(true);
        await props.onSubmit(carrierValue, parcelTrackerValue);
        setIsAnnouncementInProgress(false);
    };

    return <Fragment>
        <DialogTitle>
            {t("components.parcel.btmAssignTracker.form.single.title", { parcel: props.parcel.id })}
        </DialogTitle>
        <DialogContent data-testid={"tracker-announcement-dialog"}>
            <Typography className={"label-and-assign__description"}>
                {t("components.parcel.btmAssignTracker.form.single.description")}
            </Typography>
            <div className={"btm-tracker-announce-dialog__form"}>
                <FormControl fullWidth variant={"outlined"}>
                    <FormLabel htmlFor={"btm-tracker-announcement-carrier"}>
                        {t("components.parcel.btmAssignTracker.form.single.label.carrier")}
                    </FormLabel>
                    <TextField id={"btm-tracker-announcement-carrier"}
                               value={carrierValue}
                               variant={"outlined"}
                               data-testid={"tracker-announcement-dialog-carrier-input"}
                               onChange={event => setCarrierValue(event.target.value ?? "")} />
                </FormControl>
                <ScanFieldControlled autoFocus textValue={parcelTrackerValue}
                                     onTextValueChange={value => setParcelTrackerValue(value)}
                                     onScan={handleParcelTrackerScanned}>
                    <FormLabel>
                        {t("components.parcel.btmAssignTracker.form.single.label.tracker")}
                    </FormLabel>
                </ScanFieldControlled>
            </div>
        </DialogContent>
        <DialogActions>
            <Button variant={"outlined"} type={"submit"} key={"cancel-btn"}
                    data-testid={"tracker-announcement-dialog-close-button"}
                    onClick={props.onCancel}>
                {t("components.parcel.btmAssignTracker.form.single.cancel")}
            </Button>
            <Button color={"secondary"}
                    data-testid={"tracker-announcement-dialog-submit-button"}
                    variant={"contained"}
                    type={"submit"}
                    key={"submit-btn"}
                    disabled={carrierValue === "" || parcelTrackerValue === "" || isAnnouncementInProgress}
                    onClick={handleParcelTrackerAnnouncement}>
                {t("components.parcel.btmAssignTracker.form.single.submit")}
            </Button>
        </DialogActions>
    </Fragment>;
};
